import { useCallback, useMemo } from 'react';
import { StringParam, useQueryParams } from 'use-query-params';
import type { AdsHistoryGroupedFilterValues } from '../utils/adsHistoryGroupedFilters';

const QUERY_PARAMS = {
  user: StringParam,
  flow: StringParam,
  hypothesis: StringParam,
  customer: StringParam,
  technology: StringParam,
  status: StringParam,
};

const toParam = (value: string) => value || undefined;

/**
 * Grouped ads-history filters kept in the URL under the same names the backend
 * `CabinetAdsHistoryGroupedRequest` accepts, so a filtered view survives a reload and can be shared.
 */
const useAdsHistoryGroupedParams = () => {
  const [query, setQuery] = useQueryParams(QUERY_PARAMS);

  const filters = useMemo<AdsHistoryGroupedFilterValues>(
    () => ({
      user: query.user ?? '',
      flow: query.flow ?? '',
      hypothesis: query.hypothesis ?? '',
      customer: query.customer ?? '',
      technology: query.technology ?? '',
      status: query.status ?? '',
    }),
    [query],
  );

  const setFilters = useCallback(
    (next: AdsHistoryGroupedFilterValues) => {
      setQuery(
        {
          user: toParam(next.user),
          flow: toParam(next.flow),
          hypothesis: toParam(next.hypothesis),
          customer: toParam(next.customer),
          technology: toParam(next.technology),
          status: toParam(next.status),
        },
        'replaceIn',
      );
    },
    [setQuery],
  );

  return { filters, setFilters };
};

export default useAdsHistoryGroupedParams;
